import Vue from 'vue';

export default {
	get(sites, language) {
		const promisifiedSiteRequests = sites.map((site) => {
			const id = site.PKM_Seite;

			return new Promise((resolve, reject) => {
				Vue.http.post(process.env.GET_SITE_URL,
					{ FKM_Seite: id, sprache: language, layoutpart: 'body', modus: 'edit' })
				.then((response) => {
					response.body.id = id;
					response.body.meta = { ...site, sprache: language, loading: false };

					resolve(response.body);
				}, (response) => {
					reject(response);
				});
			});
		});

		return Promise.all(promisifiedSiteRequests);
	},

	save(ids, language, data) {
		const promisifiedSiteRequests = ids.map(id =>
			new Promise((resolve, reject) => {
				Vue.http.post(process.env.SAVE_SITE_URL,
				{ FKM_Seite: id, sprache: language, items: data[id] })
				.then((response) => {
					resolve(response.body);
				}, (response) => {
					reject(response);
				});
			}),
		);

		return Promise.all(promisifiedSiteRequests);
	},

	delete(id, objectId) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.DELETE_SITE,
				{ FKM_Seite: id, FKM_Objekt: objectId })
				.then((response) => {
					resolve(response.body);
				}, (response) => {
					reject(response);
				});
		});
	},

	setSiteOrder(idStrList, topicId) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CHANGE_MODULE_ORDER_URL,
			              { FKM_Seiten_string: idStrList, FKM_Thema: topicId })
			.then(() => {
				resolve();
			})
			.catch(() => {
				reject();
			});
		});
	},

	saveMAMImage(data, lang = '') {
		const size = {
			width: data.I_Sollbreite || 2000,
			height: data.I_Sollhoehe || 1000,
		};
		const postUrl = `${process.env.SAVE_MAM_IMAGE_URL}&sprache=${lang}&sollbreite=${size.width}&sollhoehe=${size.height}`;

		return new Promise((resolve, reject) => {
			Vue.http.post(postUrl, data)
			.then((response) => {
				resolve(response.body);
			}, (response) => {
				reject(response);
			});
		});
	},

	deleteImage(imageId, language, objectId) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.DELETE_IMAGE_URL,
			              { PKM_Bild: imageId, sprache: language, PKM_Objekt: objectId })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	getTemplates(objectID, topicID) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CHOOSE_TEMPLATE_URL, { FKM_Objekt: objectID, PKM_Thema: topicID })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	setTemplateForModule(objectID, moduleID, topicID, templateID) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.INSERT_MODULE_URL, { objectID, moduleID, templateID, topicID })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	insertSiteAtPosition(objectID, templateID, topicID, positionNum) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.INSERT_MODULE_URL,
				{
					FKM_Template: templateID,
					PKM_Thema: topicID,
					PKM_Objekt: objectID,
					U_Seitennummer: positionNum,
				})
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	getTemplateSets(objectID) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CHOOSE_TEMPLATESET_URL, { PKM_Objekt: objectID })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	createTemplateSet(objectID, objectTemplateSetID) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CREATE_TEMPLATESET_URL, {
				PKM_Objekt: objectID,
				set_PKM_Objekt: objectTemplateSetID,
			})
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},
};



// WEBPACK FOOTER //
// ./src/api/objectsites.js